var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_402_6499)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1456 7.71844V11.4336L13.0032 13.2912",
    stroke: "#000929",
    strokeWidth: 2.18862,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83282 10.5048C3.04096 8.46153 3.99406 6.56637 5.51029 5.18094C7.02652 3.7955 8.99974 3.01677 11.0535 2.99331C13.1072 2.96986 15.0977 3.70332 16.6452 5.05376C18.1927 6.4042 19.1888 8.27709 19.4436 10.3151C19.6983 12.3531 19.1938 14.4136 18.0264 16.1034C16.8589 17.7932 15.1102 18.994 13.1139 19.4768C11.1176 19.9596 9.01341 19.6906 7.2028 18.721C5.3922 17.7514 4.00192 16.1492 3.29722 14.22M2.83282 18.864V14.22H7.4768",
    stroke: "#000929",
    strokeWidth: 2.18862,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_402_6499"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.2911,
    height: 22.2911,
    fill: "white",
    transform: "translate(0 0.288086)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.d2e93647b02c4b2e19b2a4a28b4adcf8.svg";
export { ForwardRef as ReactComponent };